function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBubble = function SvgBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 18 17"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.9 15.8 9 13.6h5c1.8 0 3.3-1.5 3.3-3.3V4c0-1.8-1.5-3.3-3.3-3.3H4C2.2.8.8 2.2.8 4v6.4c0 1.8 1.5 3.3 3.3 3.3h2.5v1.9c0 .1.1.3.2.3 0-.1.1-.1.1-.1z",
    style: {
      fill: "none",
      stroke: "#00263e",
      strokeWidth: 1
    }
  }));
};
export default SvgBubble;